import React from 'react';
import { CourseWithGrades } from '../../../../types';
import { ExamsTable } from './exams-table';

interface ExamsTabProps {
  selectedCourse: CourseWithGrades;
}

export const ExamsTab: React.FC<ExamsTabProps> = ({ selectedCourse }) => {
  return (
    <div>
      <ExamsTable exams={selectedCourse.exams || []} />
    </div>
  );
};
